import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { ErrorService } from '@app/services/error.service';

@Component({
  selector: 'error-page',
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent implements OnInit {
  errorService = inject(ErrorService);

  ngOnInit() {
    Tracking.track(PortalTrackingEvents.ancillaryUpsellErrorPageOpened);
  }
}
